var path = 'search/userSimpleSearch.html';
var html = "<ol class=\"search-suggestions u-unstyled\"> <li class=\"search-suggestion search-suggestion-user--small\" data-ng-repeat=\"user in results\" data-ng-class=\"{'search-suggestion-active': current==$index}\" data-ng-mouseover=setCurrent($index) data-ng-click=selectResult(user)> <userimage class=search-suggestion-userimage data-user=user></userimage> <div class=search-suggestion-info> <span class=\"search-suggestion-row search-suggestion-name\">{{::user.name}} </span> <small class=search-suggestion-nickname>- {{::user.names.nickname}}</small> </div> </li> </ol> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./views/search/userSimpleSearch.html
// module id = pNQn
// module chunks = 1